import { useCallback } from 'react';
import { useUpdateUserBalance } from '@core/js/hooks/user';
import { TDynamicBalancesResponse } from '@core/js/hooks/socket/types';
import { publicEventsAPIService } from '@core/js/services/publicEventsAPI.service';
import { dispatcher } from 'dispatcher';

export const useHandleBalanceUpdateNotification = () => {
    const updateUserBalance = useUpdateUserBalance();

    return useCallback((response: TDynamicBalancesResponse): void => {
        updateUserBalance(response.data.balances);
        dispatcher.dispatch('notification-bonusCounter:updated');
        publicEventsAPIService.trigger('userBalanceUpdated', response);
    }, [updateUserBalance]);
};
